// src/portals/creator/components/CreatorSidebar.js
import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import CreatorNavLinks from "./CreatorNavLinks";
import { Home } from "lucide-react";

const CreatorSidebar = ({ isCollapsed }) => {
  const { currentUser } = useAuth();

  return (
    <aside className="w-full h-full bg-white border-r border-slate-200 flex flex-col">
      <div
        className={`p-4 border-b border-slate-200 flex items-center h-[73px] ${
          isCollapsed ? "justify-center" : ""
        }`}
      >
        <NavLink to="/dashboard" className="flex items-center">
          <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center text-white font-bold text-xl flex-shrink-0">
            A
          </div>
          {!isCollapsed && (
            <h1 className="ml-3 text-xl font-bold text-slate-800 whitespace-nowrap">
              Adnaki
            </h1>
          )}
        </NavLink>
      </div>

      <div className="flex-1 p-4 overflow-y-auto min-h-0">
        <CreatorNavLinks isCollapsed={isCollapsed} />
      </div>

      <div className="p-4 border-t border-slate-200">
        <NavLink
          to="/fan"
          title="Back to Fan App"
          className={`flex items-center w-full px-3 py-2 text-sm font-medium rounded-md transition-colors text-slate-600 hover:bg-slate-200 ${
            isCollapsed ? "justify-center" : ""
          }`}
        >
          <Home
            className={`w-5 h-5 flex-shrink-0 ${!isCollapsed ? "mr-3" : ""}`}
          />
          {!isCollapsed && <span>Back to Fan App</span>}
        </NavLink>
        <div
          className={`mt-4 flex items-center ${isCollapsed ? "hidden" : ""}`}
        >
          <img
            src={currentUser?.profilePictureUrl}
            alt={currentUser?.fullName}
            className="w-10 h-10 rounded-full flex-shrink-0"
          />
          <div className="ml-3 overflow-hidden">
            <p className="text-sm font-semibold text-slate-800 truncate">
              {currentUser?.fullName}
            </p>
            <p className="text-xs text-slate-500">Creator Account</p>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default CreatorSidebar;
